export const locales: { [key: string]: () => Promise<any> } = {
  ru: () => import('dayjs/locale/ru'),
  en: () => import('dayjs/locale/en'),
  uk: () => import('dayjs/locale/uk'),
  be: () => import('dayjs/locale/be'),
  es: () => import('dayjs/locale/es'),
};
